import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import { HttpMethods, SERVICES } from '../../services/api';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { ThunkAPI } from '../rootReducer';

export interface IUserResetPasswordRequest {
  email: string;
  password: string;
}

export interface IUserUpdatePasswordRequest {
  password: string;
  tokenId: string;
}

export const resetPasswordRequest: AsyncThunk<void, IUserResetPasswordRequest, ThunkAPI> = createAsyncThunk(
  'auth/resetPasswordRequest',
  async (email: IUserResetPasswordRequest, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IUserResetPasswordRequest>({
        endpoint: 'reset-password',
        microservice: SERVICES.AUTH_SERVICE,
        authenticated: false,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(email, thunk);
      thunk.dispatch(showSuccessMessage('You will receive an email with instructions shortly'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('Your request failed. Please contact support'));
      return thunk.rejectWithValue(err);
    }
  }
);

export const updateUserPassword: AsyncThunk<void, IUserUpdatePasswordRequest, ThunkAPI> = createAsyncThunk(
  'auth/resetPasswordRequest',
  async (data: IUserUpdatePasswordRequest, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IUserUpdatePasswordRequest>({
        endpoint: 'auth-reset-password',
        microservice: SERVICES.AUTH_SERVICE,
        authenticated: false,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(data, thunk);
      thunk.dispatch(push('/login'));
      thunk.dispatch(showSuccessMessage('Your password has been updated!'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('Your request failed. Your reset password link may have expired, please try again'));
      return thunk.rejectWithValue(err);
    }
  }
);